import { render, staticRenderFns } from "./ScreeningsUpdateBuildings.vue?vue&type=template&id=4f58aefc&scoped=true&"
import script from "./ScreeningsUpdateBuildings.vue?vue&type=script&lang=js&"
export * from "./ScreeningsUpdateBuildings.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningsUpdateBuildings.vue?vue&type=style&index=0&id=4f58aefc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f58aefc",
  null
  
)

export default component.exports